// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3VJfH","list":"PatternAutocomplete_list__w_tx-"};